<lib-card [title]="'Upload file'" [subtitle]="'Client will see the file on dashboard'">
	<ui-file-form-field
		[validation]="'allFiles'"
		[standalone]="true"
		[isRequired]="false"
		[maxFiles]="undefined"
		[imageCrop]="undefined"
		[uploadFunction]="uploadFunction"
		(valueChange)="handleFilesChange($event)"
	></ui-file-form-field>
</lib-card>

<div class="push-top">
	@if (clientFiles(); as clientFiles) {
	<div>
		@if (clientFiles.length) {
		<div>
			<lib-card>
				@for (file of clientFiles; track file.fileReference.absoluteUrl; let first = $first) {
				<div>
					@if (!first) {
					<lib-divider class="push-top push-bottom"></lib-divider>
					}
					<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
						@if (file.fileReference.image) {
						<div libFlexColumn [libFlexSize]="'50px'">
							<lib-image
								[alt]="'Client file'"
								[isRound]="false"
								[isResponsive]="true"
								[imageSize]="'50px'"
								[image]="file.fileReference.image"
								[dialogPreviewImage]="file.fileReference.image"
							></lib-image>
						</div>
						}
						<div libFlexColumn libFlexFill>
							<div libLineClamp [clampLines]="isMobileView() ? 1 : 2">
								{{ file.fileReference.originalFilename }}
							</div>
							<div libLineClamp [clampLines]="1" libText3>
								{{ file.formattedFileSize }}
							</div>
						</div>
						@if (!isMobileView()) {
						<div libFlexColumn>
							<lib-link
								[routerLink]="undefined"
								[externalUrl]="file.fileReference.absoluteUrl"
								[linkStyle]="'noUnderline'"
							>
								<lib-button [buttonType]="'primaryLight'">Download</lib-button>
							</lib-link>
						</div>
						}
						<div libFlexColumn>
							<lib-button-list [mode]="'single'" [buttons]="file.buttons"></lib-button-list>
						</div>
					</div>
					@if (isMobileView()) {
					<div class="push-top-sm">
						<lib-link
							[routerLink]="undefined"
							[externalUrl]="file.fileReference.absoluteUrl"
							[linkStyle]="'noUnderline'"
						>
							<lib-button [buttonType]="'primaryLight'">Download</lib-button>
						</lib-link>
					</div>
					}
				</div>
				}
			</lib-card>
		</div>
		} @else {

		<lib-message [type]="'noDataOnBody'">
			@if (authUserIsClient()) { You have no assigned files } @else { Client has no assigned files }
		</lib-message>

		}
	</div>
	}
</div>
